"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MessageTextContentWeb = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styled_1 = require("@hiyllo/ux/styled");
var react_markdown_1 = __importDefault(require("react-markdown"));
var remark_gfm_1 = __importDefault(require("remark-gfm"));
var MessageTextContainer = (0, styled_1.styled)("div", {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
});
exports.MessageTextContentWeb = react_1["default"].memo(function MessageTextContentWeb(props) {
    return ((0, jsx_runtime_1.jsx)(MessageTextContainer, __assign({ onClick: props.onClickHandler, className: "MessageTextContainer" }, { children: (0, jsx_runtime_1.jsx)(react_markdown_1["default"], __assign({ remarkPlugins: [remark_gfm_1["default"]], components: {
                a: function (_a) {
                    var _b;
                    var node = _a.node, props = __rest(_a, ["node"]);
                    return ((0, jsx_runtime_1.jsx)("a", __assign({}, props, { href: (_b = props.href) === null || _b === void 0 ? void 0 : _b.replace(/&amp;/g, "&"), target: "_blank", rel: "noreferrer" })));
                }
            } }, { children: props.content.text })) })));
});
